import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpencontainersinitiativeComponent } from './simple-icons-opencontainersinitiative.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpencontainersinitiativeComponent ],
    exports:      [ SimpleIconsOpencontainersinitiativeComponent ],
    bootstrap:    []
})
export class SimpleIconsOpencontainersinitiativeModule {}
